/**
 * WHILE A SCENARIO PLAYS, THE SITE'S SCREENS FOLLOW IT (2026-10-21). A grid failure moves in
 * phases of 15–30 s, and the cards poll at their own, slower pace, so the Overview said "DG OFF"
 * for a minute after the generator had started. For a simulated site with a scenario playing, every
 * active query is refetched about every 15 s — the generator's own cadence while a scenario plays.
 * Nothing changes for a real site, or for a simulated one that is just running.
 *
 * Reads the Playground's list only for someone who may run simulations (`simulations.run`): the only
 * people who can be looking at a demo site at all.
 */
import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useSiteContext } from '@/app/site-context-value';
import { useMe } from '@/lib/api/me';
import { useSimulations } from '@/lib/api/simulations';

const EVERY_MS = 15_000;

export function useSimulationRefresh(): void {
  const { selected } = useSiteContext();
  const me = useMe();
  const may = me.data?.permissions.includes('simulations.run') ?? false;
  const sims = useSimulations(may && selected?.simulated === true);
  const playing = sims.data?.simulations.some((s) => s.site.id === selected?.id && s.active !== null) ?? false;
  const qc = useQueryClient();
  useEffect(() => {
    if (!playing) return;
    const id = window.setInterval(() => void qc.refetchQueries({ type: 'active' }), EVERY_MS);
    return () => window.clearInterval(id);
  }, [playing, qc]);
}
